import {
  Engagement,
  EngagementConsentSettings,
  EngagementDocumentContactMapping,
  EngagementJobResponse,
  EngagementPrepaymentResponse,
  EngagementStepType
} from '@aiwyn/api';
import { BaseContact, EditableFileResponse, Loadable, LoadableStatus } from '@aiwyn/shared';
import { EngagementsCurrentStepRef, EngagementsPendingChanges } from '../models';

export interface MultipleIdentitySigningState {
  documentContactMappings: EngagementDocumentContactMapping[];
  activeSigningContactId: number | null;
  contactProfiles: BaseContact[];
}

export interface EngagementsStateModel {
  tableSearchValue: string;

  selectedEngagementId?: number;
  selectedEngagement: Loadable<Engagement>;

  selectedDocuments: Record<number, Loadable<EditableFileResponse>>;
  selectedEngagementJobs: Loadable<EngagementJobResponse[]>;
  selectedEngagementPrepayment: Loadable<EngagementPrepaymentResponse>;
  selectedEngagementConsentSettings?: EngagementConsentSettings;

  engagementsCurrentStepRef?: EngagementsCurrentStepRef;
  engagementsPendingChanges: EngagementsPendingChanges;

  multipleIdentitySigningState?: MultipleIdentitySigningState;
}

export const DEFAULT_ENGAGEMENT_STATE_MODEL: EngagementsStateModel = {
  tableSearchValue: '',

  selectedEngagement: { status: LoadableStatus.DEFAULT },
  selectedDocuments: {},
  selectedEngagementJobs: { status: LoadableStatus.DEFAULT },
  selectedEngagementPrepayment: { status: LoadableStatus.DEFAULT },

  engagementsCurrentStepRef: {},
  engagementsPendingChanges: {},
};

export const ENGAGEMENT_STEP_ORDER_MAP: Record<EngagementStepType, number> = {
  [EngagementStepType.LETTER]: 0,
  [EngagementStepType.CONSENT]: 1,
  [EngagementStepType.ADD_ON]: 2,
  [EngagementStepType.PAYMENT]: 3,
};